const containerWidth = 110;
const ratio = 0.78;

const styles = theme => ({
  container: props => ({
    width: props.containerWidthPx || containerWidth,
    height: props.containerWidthPx * ratio || containerWidth * ratio,
    marginLeft: '4px',
    marginRight: '4px',
  }),
  titleField: {
    marginTop: '10px',
    display: 'flex',
    background: 'linear-gradient(90deg, rgba(124,85,229,1) 0%, rgba(99,163,242,1) 100%);',
    alignItems: 'center',
    // justifyContent: 'space-between',
    padding: [0, 7],
    height: '30px',
    borderRadius: '5px 5px 0 0',
    fontSize: 8,
  },
  playerIcon: {
    marginTop: '-15px',
  },
  title: {
    color: 'white',
    marginLeft: '5px',
    width: 'calc(100% - 30px)',
    height: '30px',
  },
  nameSpan: {
    // textOverflow: 'ellipsis',
    // overflowX: 'hidden',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 1,
    overflow: 'hidden',
  },
  potSpan: {
    extend: 'nameSpan',
  },
  contentField: {
    background: '#414752',
    borderRadius: '0 0 5px 5px',
  },
  description: {
    color: 'white',
    textAlign: 'center',
    // margin: '5px 0',
    fontSize: 8,
  },
  hidden: {
    visibility: 'hidden',
  },
  combination: {
    // margin: '5px 0',
    padding: [0, 3],
    display: 'flex',
    justifyContent: 'center',
    // flexWrap: 'nowrap',
    flexWrap: 'nowrap',
    width: '100%',
    minHeight: '5px',
  },
  pokerCard: {
    display: 'block',
  },
  pokerCardHand: {
    marginTop: '-5px',
  },
  cards: {
    display: 'flex',
    flexWrap: 'nowrap',
    width: '50px',
  },
});

export default styles;
